import { useEffect, useState } from 'react'
import {
  isGrowthEngineHomeTipReady,
  subscribeGrowthEngineHomeTipBadge,
} from 'src/utils/growthEngineHomeTipBadge'

export default function useGrowthEngineHomeTipBadge() {
  const [ready, setReady] = useState(isGrowthEngineHomeTipReady)
  useEffect(() => subscribeGrowthEngineHomeTipBadge(setReady), [])
  return ready
}
